import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectUser = createFeatureSelector<any>('user');

export const selectUserState = createSelector(
    selectUser,
    (state: any) => state,
);
